const IconArrowRightSpacing = props => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M5.80283 12.8632C5.5433 12.6037 5.54314 12.1829 5.80247 11.9232L9.71967 8.00004L5.80247 4.07689C5.54314 3.81716 5.5433 3.39642 5.80283 3.13689C6.0625 2.87721 6.48351 2.87721 6.74319 3.13689L10.8992 7.29293C11.2898 7.68346 11.2898 8.31662 10.8992 8.70715L6.74319 12.8632C6.48351 13.1229 6.0625 13.1229 5.80283 12.8632Z"
			fill="currentColor"
		/>
	</svg>
);
export default IconArrowRightSpacing;
